// Converts a progress tick's position delta into wall-clock watch-time
// credit, in seconds.
//
// Players report CONTENT-position deltas: at 2x speed the position advances
// ~2s of content per 1s of real time. Credited hours (dashboard stat and the
// CRM weekly-checkin sync) are wall-clock — the time the participant actually
// spent watching — so the delta is divided by the playback rate.
//
// The seek guard must scale with the rate for the same reason: a fixed
// "delta < maxTick" cutoff reads every 2x tick (~2s of content) as a seek and
// credits nothing (the bug this file fixes). Deltas outside
// (0, maxTickSeconds * rate) are seeks, scrubs, or player glitches and credit 0.
export default function creditedSeconds(delta, playbackRate, maxTickSeconds) {
  const rate = playbackRate > 0 ? Number(playbackRate) : 1;
  if (!(delta > 0) || delta >= maxTickSeconds * rate) return 0;
  return delta / rate;
}
